import { lazy } from 'react';
const SheetWastage = lazy(() => import('./SheetWastage'));

const SheetWastageRoutes = [
  {
    path: '/sheetwastage',
    component: SheetWastage
  }
];

export default SheetWastageRoutes;
